export default "__VITE_ASSET__D$sp_lgX__"